import React, { Component } from 'react';
import './Header.css';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { Route, Switch } from 'react-router-dom';
import channelList from '../components/ChannelList'
const { Content } = Layout;
class RightSide extends Component {
  render() {
    return (
        <div className="rightSide" id="rightSide">
        <Content style={{ margin: '0 16px'}}>
            <Switch>
                <Route path="/" exact component={channelList}></Route>
            </Switch>
        </Content>
        </div>
    );
  }
}

const mapState = (state) => {
  return {
  }
}

const mapDispatch = (dispatch) => {
  return {
  }
}

export default connect(mapState, mapDispatch)(RightSide);


// WEBPACK FOOTER //
// ./src/layouts/RightSide.js